import { TypographyVariants, Theme as Typography } from "../Typography/Typography.theme";

export const Theme = {
  wrapper: [
    Typography.typography,
    TypographyVariants.body1,
    "[&_b]:font-bold [&_strong]:font-bold",
    "[&_i]:italic [&_em]:italic",
    "[&_u]:underline",
    "[&_s]:line-through [&_strike]:line-through",
    "[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-1",
    "[&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-1",
    "[&_ul_ul]:list-[circle] [&_ul_ul]:pl-6 [&_ul_ul]:my-0",
    "[&_ol_ol]:list-decimal [&_ol_ol]:pl-6 [&_ol_ol]:my-0",
    "[&_ul_ol]:list-decimal [&_ul_ol]:pl-6 [&_ul_ol]:my-0",
    "[&_ol_ul]:list-[circle] [&_ol_ul]:pl-6 [&_ol_ul]:my-0",
    "[&_li]:my-0.5",
    "[&_li>p]:my-0",
    "[&_p]:mb-1 last:[&_p]:mb-0",
    "[&_h1]:text-2xl [&_h1]:font-bold [&_h1]:mb-2",
    "[&_h2]:text-xl [&_h2]:font-bold [&_h2]:mb-2",
    "[&_h3]:text-lg [&_h3]:font-bold [&_h3]:mb-1",
    "[&_h4]:text-base [&_h4]:font-bold [&_h4]:mb-1",
    "[&_a]:text-primary [&_a]:underline",
    "[&_table]:border-collapse [&_table]:w-full [&_table]:my-2",
    "[&_td]:border [&_td]:border-neutral-30 [&_td]:p-2",
    "[&_th]:border [&_th]:border-neutral-30 [&_th]:p-2 [&_th]:font-bold",
    "[&_blockquote]:border-l-4 [&_blockquote]:border-neutral-30 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:my-2",
    "[&_code]:bg-neutral-20 [&_code]:px-1 [&_code]:rounded",
    "[&_pre]:whitespace-pre [&_pre]:bg-neutral-20 [&_pre]:p-2 [&_pre]:rounded",
    "whitespace-normal",
    "break-words"
  ],
};